import {
  Pipe,
  PipeTransform,
} from '@angular/core';
import {NumberConverter} from '../functions/number-converter';
import {Constants} from '../constants/constants';

@Pipe({
  name: 'roundPercentage',
})
export class RoundPercentagePipe implements PipeTransform {

  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return Constants.DASH;
    }
    return NumberConverter.roundNumber(value) + Constants.PERCENT;
  }

}
